import React from 'react';
import { format, parseISO } from 'date-fns';
import type { Appointment } from '../../../services/clinicsService';
import { calculateTopPercentage, calculateHeightPercentage } from './positioningEngine';
import { getStatusColorClasses } from '../../../utils/appointmentStatus';

interface AppointmentCardProps {
  appointment: Appointment;
  onClick?: (app: Appointment, e: React.MouseEvent) => void;
}

export default function AppointmentCard({ appointment, onClick }: AppointmentCardProps) {
  const topPercentage = calculateTopPercentage(appointment.start_time);
  const heightPercentage = calculateHeightPercentage(appointment.start_time, appointment.end_time);

  const colorClasses = getStatusColorClasses(appointment.status);

  return (
    <div data-ui="appointment-card-region-001"
      onClick={(e) => { e.stopPropagation(); onClick?.(appointment, e); }}
      className={`clinics-appointment-status-tag absolute left-1 right-1 rounded-md border p-1 text-xs overflow-hidden cursor-pointer backdrop-blur-md transition-all hover:brightness-125 ${colorClasses}`}
      style={{ top: `${topPercentage}%`, height: `${heightPercentage}%`, zIndex: 10 }}
    >
      <div data-ui="appointment-card-region-002" className="font-semibold truncate drop-shadow-md [text-shadow:_0_1px_3px_rgb(0_0_0_/_60%)]">
        {format(parseISO(appointment.start_time), 'HH:mm')} - {appointment.patient_name || `Patient #${appointment.patient_id}`}
      </div>
      <div data-ui="appointment-card-region-003" className="truncate opacity-90 drop-shadow-md [text-shadow:_0_1px_2px_rgb(0_0_0_/_60%)]">
        {appointment.appointment_type}
      </div>
    </div>
  );
}
